<template>
    <div class="coupon-goods-page">
        <NavBar title="优惠商品" >
            <template #stickyBox>
                 <van-tabs v-model="goodsKinds" @click="handleTab"  v-if="goodsList.length">
                    <van-tab v-for="(item,index) in goodsList" :key="index" :name="item.name" :title="item.title" />
                </van-tabs> 
            </template>
        </NavBar>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                v-model="loading"
                :finished="finished"
                loading-text="加载中"
                :finished-text="filter.pageNum != 1 && listData.length? '-没有更多了-' : ''"
                :error.sync="error"
                error-text="加载失败，重试"
                :immediate-check="false"
                @load="onLoad"
            >
                <!-- 实物 -->
                <div v-show="goodsKinds == 3">
                    <div class="block-item">
                        <div class="entity-goods-list">
                            <EntityGoodsItem v-for="item in listData" :key="item.id" :data="item" />
                        </div>
                    </div>
                </div>
                <!-- 培训 -->
                <div v-show="goodsKinds == 1">
                    <div class="block-item">
                        <div class="goods-list">
                            <GoodsItem v-for="item in listData" :key="item.id" :data="item" />
                        </div>
                    </div>
                </div>
                <div class="no-data" v-if="loaded && !listData.length">
                    <empty description="暂无可用优惠商品" />
                </div>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
import NavBar from '../../../components/NavBar/index.vue';
import EntityGoodsItem from '../components/entityGoods.vue';
import GoodsItem from '../components/goodsItem.vue';
export default {
    components: {
        NavBar,
        GoodsItem,
        EntityGoodsItem,
    },
    data() {
        return {
            error: false,
            dataLoading: false,
            loading: true,
            finished: false,
            refreshing: false,
            goodsList: [{
                title: '实物商品',
                name: 3
            }, {
                title: '培训商品',
                name: 1
            }],
            filter: {
                pageNum: 1,
                pageSize: 10,
            },
            isInit: true,
            loaded: false,
            branchId: this.$route.query.branchId,
            goodsKinds: 3,
            listData: [],
        }
    },
    created () {
        this.getDataList();
    },
    methods: {
        getDataList() {
            this.dataLoading = true;
            this.$api.coupon.couponAllGoodsList({
                branchId: this.goodsKinds == 3 ? '' : this.branchId,
                goodsKinds: this.goodsKinds,
                saasId: localStorage.getItem('saasId'),
            },this.filter).then((res)=>{
                if(res.success) {
                    this.error = false;
                    this.loaded = true;
                    if (this.refreshing) {
                        this.listData = [];
                        this.refreshing = false;
                    }
                    const {list, total} = res.data
                    if(this.filter.pageNum === 1) {
                        this.listData = list;
                    } else {
                        this.listData = this.listData.concat(list);
                    }
                    this.loading = false;
                    if(this.listData.length >= total) {
                        this.loading = true;
                        this.finished = true;
                    } else {
                        this.filter.pageNum++;
                    }
                } else {
                    this.error = true;
                    this.loading = false;
                }
                this.dataLoading = false;
            },()=>{
                this.error = true;
                this.loading = false;
                this.dataLoading = false;
            })
        },
        onLoad() {
            this.getDataList();
        },
        onRefresh() {
            this.finished = false;
            this.loading = true;
            this.filter.pageNum = 1;
            this.onLoad();
        },

        handleTab1(index) {
            this.$router.replace(`/couponGoodsList?ucode=${this.ucode}&type=${index}`)
            this.loaded = false;
            this.getCurrentData(String(index), this.allData)
        },
        onChangePage(page = 1) {
            window.scrollTo(0,0)
            this.finished = false;
            this.filter.pageNum = page;
            this.getDataList();
        },
        handleTab(value) {
            this.goodsKinds = value;
            this.orderType = '';
            this.onChangePage();
        },
    },
}
</script>
<style lang="less" scoped>
    ::v-deep {
        .van-tabs {
            padding: 24/37.5rem 0 48/37.5rem;
            background-color: #fff;
            margin-bottom: 24/37.5rem;
        }
        .van-tabs__wrap {
            height: 34/37.5rem;
            
            .van-tabs__nav {
                background-color: transparent;
                justify-content: flex-start;
                padding-left: 32/37.5rem;
            }
            .van-tab {
                font-size: 32/37.5rem;
                line-height: 40/37.5rem;
                color: #999;
                position: relative;
                z-index: 2;
                padding: 0;
                flex: 1 0 auto;
                margin-right: 32/37.5rem;
                &:last-of-type {
                    margin: 0;
                }
                &.van-tab--active {
                    color: #333;
                }
            }
            .van-tabs__nav--line {
                padding-bottom: 0;
            }
            .van-tabs__line {
                background-color: #025EFE;
                width: 62/37.5rem;
                height: 8/37.5rem;
                bottom: 0;
                border-radius: 0;
            }
        }
    }
    .coupon-goods-page {
        min-height: 100vh;
        background-color: #F8FAFC;
        padding-bottom: 110px;
        .block-item {
            margin-top: 20px;
            padding: 0 24px;
            &:first-child {
                margin-top: 0;
            }
            .block-title {
                color: #333;
                font-size: 32px;
                line-height: 40px;
                padding: 0;
                font-weight: 500;
                margin-bottom: 20px;
            }
            .goods-list {
                ::v-deep {
                    .goods-item {
                        margin-bottom: 20px;
                    }
                }
            }
            .entity-goods-list {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                height: 100%;
                ::v-deep {
                    .entity-goods-item {
                        margin-bottom: 20px;
                    }
                }
            }
        }
    }
</style>